const initialdata = {
    userData: {},
    MenuData: [],
    UserAccessData: [],
    Partner_Account_Details: [],
    NotificationsData: [],
    AccessToken: '',
    isAuthenticated: false,
    selectedOrganization: null,
    availableOrganizationData: []
}

const asyncReducer = (state = initialdata, action) => {
    // //debugger;
    switch (action.type) {
        case "set-user-info":

            return Object.assign({}, state, {
                userData: action.user.Data.User,
                AccessToken: action.user.Data.AccessToken,
                MenuData: action.user.Data.MenuData,
                Partner_Account_Details: action.user.Data.Partner_Account_Details,
                NotificationsData: action.user.Data.NotificationsData,
                UserAccessData: action.user.Data.UserAccessData,
                isAuthenticated: true
            });
        case "logout":
            //debugger;
            return initialdata;
        case "set-selected-organization":
            //debugger;
            return {
                ...state,
                selectedOrganization: action.payload
            };
        case "set-available-organization-data":
            return {
                ...state,
                availableOrganizationData: action.payload
            };
        default:
            return state;

    };
}

export default asyncReducer;